// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alliedUniversitySideNavigationListStyles } from "@awc/App/Widgets/AlliedUniversitySideNavigation/AlliedUniversitySideNavigationList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { AuAccordion, color, mergeWithCss } from "@awc/XDL/Utilities";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

alliedUniversitySideNavigationListStyles.linkAccordionSection = {
    ...mergeWithCss(AuAccordion, {
        headerProps: {
            css: css`
                &:first-of-type {
                    border-top: 1px solid ${color("common.ui22")};
                }
            `,
        },
    }),
};
alliedUniversitySideNavigationListStyles.link = {
    css: css`
        ${StyledTypography} {
            ${({ isSubLink }: any) =>
            isSubLink &&
            css`
                    color: ${color("common.ui30", 0.6)};
                    font-size: ${fontConfig.fontSize.regular}px;
                    line-height: ${fontConfig.lineHeight.singleLineRegular};
                    font-weight: ${fontConfig.weight.regular};
                    margin-left: 15px;
                `}
        }
    `,
};
alliedUniversitySideNavigationListStyles.splitter = {
    css: css`
        border-top: 1px solid ${color("common.ui22")};
        ${({ marginBottom }: any) => `margin-bottom: ${marginBottom}px`}
    `,
};
